import styled from '@emotion/styled';

export const SadaApplicantFormSignup = styled.div`
  max-width: 100%;
  width: 400px;
`;
